/**
 * This function converts an object into a FormData object
 * Nested objects are added as: "parentKey.nestedParentKey.nestedKey"
 * Array values are added as: "parentKey-elementIndex"
 * Other values are added regularly
 */
export const objectToFormData = (obj: object) =>
  Object.entries(obj).reduce((formData, [key, value]) => {
    typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)
      ? appendNestedObjects(formData, key, value)
      : Array.isArray(value)
      ? value.forEach((curr, index) => formData.append(`${key}.${index}`, curr))
      : formData.append(key, value)
    return formData
  }, new FormData())

const appendNestedObjects = (formData: FormData, parentKey: string, obj: object) =>
  Object.entries(obj).forEach(([nKey, nValue]: [a: string, b: any]) => {
    const newKey = `${parentKey}.${nKey}`
    typeof nValue === 'object' ? appendNestedObjects(formData, newKey, nValue) : formData.append(newKey, nValue)
  })
